<template>
    <div>
        <div class="container-fluid white-bg no-shadow">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <p>Современные школьники проводят много времени, играя на планшете, телефоне или компьютере. Чтобы ребенок проводил время с пользой, рекомендуем записать его на онлайн курсы английского языка для школьников от международной сети образовательных центров &laquo;Полиглотики&raquo;.</p>

                        <p>Мы создали уникальную образовательную платформу HomeTeacher, которая позволяет изучать иностранный язык онлайн детям от 1 года до 12 лет.</p>

                        <h2 class="greenh2">Преимущества платформы</h2>

                        <p>С HomeTeacher дистанционное обучение школьников английскому языку через Интернет будет по-настоящему эффективным, ведь для создания уроков используются те же методики, что и при проведении традиционных офлайн-уроков в классе.</p>

                        <h2 class="greenh2">Наша платформа предлагает:</h2>

                        <ol>
                            <li><span>Выгодные цены: стоимость одного занятия начинается всего от 90 рублей, а месячный курс обучения обойдется от 1000 рублей. Это намного дешевле, чем стоимость традиционных языковых курсов.</span></li>
                            <li><span>Гибкий график: ребенок может посещать онлайн уроки английского для школьников в любое удобное время, не привязываясь к графику учителя или распорядку работы центра.</span></li>
                            <li><span>Профессиональные преподаватели: в создании видео уроков принимают участие опытные педагоги, методисты, психологи и дизайнеры. Благодаря этому каждый курс ориентирован на учеников конкретного возраста. Для детей 9 или 10 лет важную роль играет элемент игры в обучении, поэтому ключевое внимание уделяется игровым видам деятельности. Дети от 11 лет уже более взрослые и самостоятельные, поэтому и уроки для них становятся сложнее.</span></li>
                            <li><span>Постоянный доступ к обучающим материалам: после оплаты курса все методические рекомендации, материалы, видео и тренажеры остаются в свободном доступе в личном кабинете в течение 12-18 месяцев. Занятие в любой момент можно поставить на паузу или воспроизвести неограниченное количество раз, чтобы ребенок лучше усвоил новый материал.</span></li>
                        </ol>

                        <p>Мы позаботились, чтобы онлайн обучение школьников английскому языку было доступно каждому. Чтобы пользоваться платформой, совсем не обязательно использовать мощный компьютер: изучение можно проводить на любом электронном устройстве с доступом к Интернету.</p>

                        <h2 class="greenh2">Какие результаты дает платформа?</h2>

                        <p>Онлайн школа для школьников по английскому языку позволяет не только достичь хорошего уровня владения иностранным, но и способствует всестороннему развитию ребят:</p>

                        <ul>
                            <li><span>Общаясь с репетитором-носителем языка или опытным педагогом, дети гораздо быстрее преодолевают языковой барьер, учатся воспринимать и понимать английскую речь на слух.</span></li>
                            <li><span>У детей быстро формируется активный словарный запас, необходимый для ведения полноценного диалога.</span></li>
                            <li><span>Поскольку ребенок формирует график самостоятельно (с помощью родителей), он становится более дисциплинированным и ответственным.</span></li>
                        </ul>

                        <p>На занятиях виды деятельности постоянно меняются, поэтому концентрация внимания ребенка остается стабильно высокой. Это пробуждает интерес к учебе, помогает сформировать правильную мотивацию и желание учиться.</p>

                        <p>Чтобы записаться на видеокурс, достаточно зайти на сайт &laquo;Полиглотики&raquo;, во вкладке HomeTeacher указать возраст ребенка и язык, который он планирует изучать, а система автоматически подберет несколько подходящих вариантов. После оплаты курса приступать к изучению можно сразу или в любое удобное время.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Lang1Age3"
    }
</script>

<style scoped>
    .no-shadow p,li{color: #000; font-size: 18px;}
    .no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
    .no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
    .no-shadow{margin-bottom: 70px;}
    .no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
    .no-shadow li span {font-family: "Manrope Light"; color: #000;}
    .no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
